import { usePaywallContext } from '@frontend/react-domain';
import { Text, XStack, YStack } from '@frontend/web-react';
import { CalloutBadge } from '@frontend/web-react/components/Primitives/Badges';
import { applyClass } from '@frontend/web-utils';
import { PaywallSelectionItem } from '../../PaywallSelectionItem';

export const SubscriptionOption = () => {
  const { paywallActions, paywallState } = usePaywallContext();

  const promotionTranslation = paywallState.promotionTranslation;
  const isSelected = paywallState.purchase.selectedPurchaseType === 'Subscription';

  return promotionTranslation ? (
    <PaywallSelectionItem
      accessibilityLabel={
        isSelected
          ? 'Subscription option selected'
          : 'Select subscription option to subscribe'
      }
      bg="trueWhite"
      isSelected={isSelected}
      leftContent={
        <YStack flex={1} gapY="xs">
          <XStack alignItems="center" gapX="md">
            <Text type="h4">
              {paywallState.promotionTranslation.hasAppliedPromoCode
                ? paywallState.promotionTranslation.promotionName
                : 'Subscribe and Save'}
            </Text>
            <CalloutBadge>MOST POPULAR</CalloutBadge>
          </XStack>
          <YStack flexShrink={1} gapY="xs">
            <Text
              className={applyClass(
                Boolean(paywallState.promotionTranslation.promotionDetails?.displayLabel),
                'italic',
              )}
              type="p-sm"
            >
              {paywallState.promotionTranslation.hasAppliedPromoCode
                ? paywallState.promotionTranslation.promotionDescription
                : 'Pick a subscription to get discounted credits monthly'}
            </Text>
          </YStack>
        </YStack>
      }
      onClick={() => {
        paywallActions.purchase.onSelectPaymentType({ type: 'Subscription' });
      }}
    />
  ) : null;
};
